import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Buttons, Spacer, boxContainer, questionnaireComponents } from "..";

import "./styles.css";

const People = ({ setPage }) => {
  const questionnaire = useSelector(
    (state) => state?.students?.student?.profileBuilder
  );

  const [state, setState] = useState({
    sameUniAsClassmates: "",
    alumniRecommendation: "",
  });

  useEffect(() => {
    setState({
      sameUniAsClassmates: questionnaire?.sameUniAsClassmates ?? "",
      alumniRecommendation: questionnaire?.alumniRecommendation ?? "",
    });
  }, [questionnaire]);

  return (
    <boxContainer.LiteBoxContainer>
      <questionnaireComponents.QuestionnaireLabel
        text="1. How important is it for you to select the same university as your
            classmates?"
        required
      />
      <Spacer height="0.625em" />
      <questionnaireComponents.QuestionnaireCircleInput
        value={state?.sameUniAsClassmates}
      />
      <Spacer height="1.5em" />
      <questionnaireComponents.QuestionnaireLabel
        text="2. How important is your school alumni university recommendation for
           you?"
        required
      />
      <Spacer height="0.625em" />
      <questionnaireComponents.QuestionnaireCircleInput
        value={state?.alumniRecommendation}
      />
      <Spacer height="1.25em" />
      <div className="flex justify-end">
        <div className="w-[12.5em]">
          <Buttons.DefaultButton
            size="large"
            width="full"
            onClick={() => setPage("Facilities")}
          >
            Next
          </Buttons.DefaultButton>
        </div>
      </div>
    </boxContainer.LiteBoxContainer>
  );
};

export default People;
